import React from "react";
import * as R from "ramda";
import { Query } from "react-apollo";

import DispositionTable from "@arachnys/catalog/_shared/Disposition/DispositionTable";
import { withApolloState } from "../../util";
import { DEFAULT_PAGESIZE_S } from "../../config";
import { GET_PROCESS_DISPOSITION } from "./queries";

const ProcessHistoryDispositionTable = ({
    processRelayId,
    dataPath = "search_results",
}) => (
    <Query
        query={GET_PROCESS_DISPOSITION}
        variables={{ id: processRelayId }}
        fetchPolicy="cache-and-network"
    >
        {withApolloState(({ data }) => {
            const tableData = R.pathOr(
                [],
                [
                    "process",
                    "processHistory",
                    "historyInput",
                    dataPath,
                    "searchResults",
                ],
                data
            );
            return (
                <DispositionTable
                    data={tableData}
                    readOnly
                    sortable
                    filterable
                    resultType="world_compliance"
                    dispositionBarConfig={{}}
                    defaultPageSize={tableData.length || DEFAULT_PAGESIZE_S}
                />
            );
        })}
    </Query>
);
export default ProcessHistoryDispositionTable;
